import { useKeycloak } from "@react-keycloak/web";
import { Button, Input, Tooltip } from "antd";
import { TableProps } from "antd/es/table";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import AddIcon from "../../../../assets/icons/AddIcon";
import EditIcon from "../../../../assets/icons/EditIcon";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import ViewIcon from "../../../../assets/icons/ViewIcon";
import CustomTable from "../../../../components/ui/CustomTable";
import Loader from "../../../../components/ui/Loader";
import { useGetAllCompanyQuery } from "../../../../features/portal/companyOnboard/companyOnboardApi";
import {
  useGetAllUsersQuery,
  useUpdateUserStatusMutation,
} from "../../../../features/portal/user/userApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatDate } from "../../../../lib/time";
import { toast } from "../../../../lib/toast";
import {
  GetAllUsersDataParamsType,
  GetAllUsersDataType,
} from "../../../../types/portal/user";
import { countParPageSerialNumber } from "../../../../utils/number";
import { addKeyInArray } from "../../../../utils/utils";
import UserPasswordChangeModal from "../../Users/UsersList/UserPasswordChangeModal";

enum Status {
  active = "status-success",
  inactive = "status-danger",
  invited = "status-info",
}

export default function UserListPermission() {
  const {
    page,
    limit,
    handlePagination,
    handleFilter,
    handleLimit,
    filter,
    keyword,
    handleSearch,
  } = useTable<GetAllUsersDataParamsType>();
  const { keycloak } = useKeycloak();
  const { open, handleOpen, handleClose } = useModal<string, any>();

  const [statusId, setStatusId] = useState<number>();
  const isAdmin2 = keycloak?.realmAccess?.roles?.includes("admin2");
  const { user, role } = useAppSelector((state) => state.auth);
  const { isError, error, isLoading, data } = useGetAllUsersQuery({
    params: {
      ...filter,
      skip: undefined,
      page,
      search: keyword,
      company_id: role === "SUPER_ADMIN" ? undefined : user?.data?.company_id,
      status: "active",
    },
  });
  const [
    updateUserStatus,
    {
      isError: updateUserStatusIsError,
      error: updateUserStatusError,
      isSuccess: updateUserStatusIsSuccess,
      isLoading: updateUserStatusIsLoading,
    },
  ] = useUpdateUserStatusMutation();
  useError(
    updateUserStatusIsError,
    updateUserStatusError,
    "update user status failed"
  );
  useEffect(() => {
    if (updateUserStatusIsSuccess) {
      toast("success", "Status updated successfully");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateUserStatusIsSuccess]);

  // company_id: role === "Admin" ? user?.data?.company_id : undefined,

  const {
    isError: isAllCompanyError,
    error: allCompanyError,
    data: allCompanyData,
  } = useGetAllCompanyQuery({
    params: {
      company_id: role === "SUPER_ADMIN" ? undefined : user?.data?.company_id,
      page: 1,
      limit: 1000000000000,
    },
  });
  useError(isError, error, "Get all user fail");
  useError(isAllCompanyError, allCompanyError, "Get all company fail");

  useEffect(() => {
    if (isAdmin2) {
      handleFilter("company_id", user?.data?.company_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin2, user?.data?.company_id]);

  const columns: TableProps<
    GetAllUsersDataType["data"]["users"][0]
  >["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "User Name",
      dataIndex: "username",
      render: (val: string) => (val ? val : "N/A"),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (val: string) => (val ? val : "N/A"),
    },
    {
      title: "Company",
      dataIndex: "company",
      render: (val) => (val ? val?.company_name : "N/A"),
    },
    {
      title: "Created at",
      dataIndex: "created_at",
      render: (val) => (val ? formatDate(val) : "N/A"),
    },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   render: (val: keyof typeof Status, record) => (
    //     <div className="flex items-center gap-1">
    //       <Switch
    //         checked={val === "active"}
    //         onChange={(checked) => {
    //           updateUserStatus({
    //             email: record?.email,
    //             enabled: checked,
    //           });
    //           setStatusId(record?.id);
    //         }}
    //         loading={statusId === record?.id && updateUserStatusIsLoading}
    //         disabled={updateUserStatusIsLoading}
    //       />
    //       <span className={Status[val]}>{capitalize(val || "-")}</span>
    //     </div>
    //   ),
    // },
    {
      title: "Actions",
      // dataIndex: "id",
      align: "center",
      render: (val) => (
        <div className="flex justify-center items-center gap-2">
          <Link to={`edit/${val?.id}`}>
            <Tooltip title="Edit User">
              <Button
                className="action-button"
                size="small"
                icon={<EditIcon />}
              />
            </Tooltip>
          </Link>

          <Link to={`view/${val?.id}`}>
            <Tooltip title="View User">
              <Button
                className="action-button"
                size="small"
                icon={<ViewIcon />}
              />
            </Tooltip>
          </Link>
        </div>
      ),
    },
  ];

  // console.log("isAdmin2:", isAdmin2);

  return (
    <>
      {open?.type === "UPDATE" && (
        <UserPasswordChangeModal
          title="Send to Approver"
          subTitle="Are you sure you want to send payment data to approver"
          buttonName="Send"
          open={open?.open}
          data={open?.data}
          handleClose={handleClose}
          action
          buttonBgDeep
          loading={isLoading}
        />
      )}

      <SidebarLayout title="User List">
        {isLoading ? (
          <Loader />
        ) : (
          <CustomTable
            loading={false}
            limit={limit}
            page={page}
            columns={columns}
            total={data?.data?.total ?? 0}
            dataSource={addKeyInArray(data?.data?.users)}
            handleLimit={handleLimit}
            handlePagination={handlePagination}
            filterSection={
              <>
                <Input
                  suffix={<SearchIcon />}
                  placeholder="Search by username, email"
                  style={{ width: 250 }}
                  allowClear
                  onChange={handleSearch}
                />

                {/* <Select
                  allowClear
                  showSearch
                  placeholder="Status"
                  filterOption={selectSearchOption}
                  options={selectStringOption(
                    Object.keys(Status),
                    "string",
                    true
                  )}
                  className="min-w-[90px]"
                  suffixIcon={<SelectDownIcon />}
                  rootClassName="icon-gray"
                  value={filter.status}
                  onChange={(val) => handleFilter("status", val)}
                /> */}

                <Link to="add">
                  <Button
                    type="primary"
                    className="middle-button"
                    icon={<AddIcon />}
                  >
                    Add New User
                  </Button>
                </Link>
              </>
            }
          />
        )}
      </SidebarLayout>
    </>
  );
}
